import { createFileRoute } from "@tanstack/react-router";
import { HubSeoContent } from "@/components/seo/HubSeoContent";
import { TopicsIndexPage } from "@/pages/topics/TopicPages";
import { breadcrumbJsonLd } from "@/config/seoConfig";
import { seoHead, SITE_BASE_URL } from "@/lib/seo/head";

export const Route = createFileRoute("/topics/")({
  // Topic data links every guide and article; importing it here (not at module
  // scope) keeps those article bodies out of every page's startup code.
  loader: async () => {
    const { TOPIC_CLUSTERS } = await import("@/content/topics");
    return { topics: TOPIC_CLUSTERS.map((t) => ({ slug: t.slug, title: t.title })) };
  },
  head: ({ loaderData }) =>
    seoHead({
      title: "Parenting Topics for Kids 8-14",
      description: "Eight parenting topics for children aged 8-14, from confidence and friendships to focus and bullying, each linking LeadXkids guides, courses and free checks.",
      canonical: "/topics",
      pageType: "CollectionPage",
      jsonLd: [
        breadcrumbJsonLd([
          { name: "Home", url: "/" },
          { name: "Topics", url: "/topics" },
        ]),
        {
          "@type": "ItemList",
          "@id": `${SITE_BASE_URL}/topics#list`,
          itemListElement: (loaderData?.topics ?? []).map((t, i) => ({
            "@type": "ListItem",
            position: i + 1,
            name: t.title,
            url: `${SITE_BASE_URL}/topics/${t.slug}`,
          })),
        },
      ],
    }),
  component: () => <><TopicsIndexPage /><HubSeoContent hub="topics" /></>,
});
